import { useScopeParams } from "@/hooks/useScopeParams";
import { PageTemplate } from "@/components/Templates/PageTemplate";

export default function AdministrativeFormRecords({
  singleSubjectId,
}: {
  singleSubjectId?: string;
}) {
  const { id } = useScopeParams();

  return (
    <PageTemplate
      title="Measures: Administrative Form Records"
      tooltipText="Explore administrative form records data, create data subsets, and download data."
      type="administrative_form_records"
      constants={{
        wikiLink:
          "/wiki/guides/exploration-measures-administrative-form-records",
        idLink: (subjectId: string) =>
          `/${id}/subjects/overview/${subjectId}/administrative-form-records`,
      }}
      subjectId={singleSubjectId}
    />
  );
}
